import React, { useState, useRef } from "react";
import { connect } from 'react-redux'
import { BiEdit } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Button, Modal } from "react-bootstrap";
import AgGridTable from "../AgGridTable";
import {
    addJobTitlesAction,
    updateJobTitlesAction,
    deleteJobTitlesAction
} from '../../../redux/actions/admin/adminAction';
import Select from "react-select";
import { groupdata } from '../helper/index'

export const JobTitle = (props) => {
    const gridRef = useRef();

    const [inputData, setInputData] = useState({ 'job_title': '', 'function': '' })
    const [show, setShow] = useState(false);

    const customStyles = {
        control: (base, state) => ({
            ...base,
            top: "5px",
            // Overwrittes the different states of border
            borderColor: state.isFocused ? "#309CCA" : "#309CCA",
        }),
    };

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setInputData({ 'job_title': '', 'function': '' })
        setShow(false)
    };

    const handleSeclect = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            ['function']: event.id
        }))
    }


    const handleChange = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value
        }))
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (inputData['id']) {
            props.updateJobTitle(inputData.id, inputData)
            handleClose()
        }
        else {
            props.addJobTitle(inputData)
            handleClose()
        }
    };

    const handleSetData = (data) => {
        setInputData(data)
        handleShow()
    }

    const handleDelete = (id) => {
        props.deleteJobTitle(id)
    }

    const [jobTitlesColumnDefs] = useState([
        { headerName: "Id", field: 'id', sort: 'asc' },
        { headerName: "Job Title", field: 'job_title', filter: true, },
        { headerName: "Function", field: 'function_name', filter: true, },
        {
            headerName: "Actions", field: 'action',
            cellRendererFramework: (params) => <>
                <BiEdit color="blue" size={20} onClick={() => handleSetData(params.data)} cursor='pointer' />
                <RiDeleteBin6Line color="red" size={20} onClick={() => handleDelete(params.data.id)} cursor='pointer' />
            </>,
            cellStyle: { textAlign: 'center' }
        },
    ])

    const defaultColDef = {
        flex: 1,
        floatingFilter: true,
        sortable: true,
        editable: false,
    }

    return (
        <div>
            <div align='right'>
                <button className="btn btn-blue"
                    onClick={() => handleShow()}
                    style={{ marginBottom: "10px" }}>Add</button>
            </div>

            <AgGridTable
                ref={gridRef}
                data={groupdata(props.functions, props.jobTitles, 'function', 'function_name')}
                defaultColDef={defaultColDef}
                columnDefs={jobTitlesColumnDefs} />

            {/* Add Form */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Job Titles</Modal.Title>
                </Modal.Header>

                <form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <h3>Job Title</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="job_title"
                                name="job_title"
                                value={inputData.job_title}
                                onChange={handleChange}
                                placeholder="Category"
                                autoComplete="off"
                            />
                        </div>
                        <br></br>
                        <h3>Function</h3>
                        <div className="">
                            <Select
                                id="function"
                                name="function"
                                options={props.functions}
                                value={inputData.function ?
                                    props.functions.find(
                                        (row) =>
                                            row.id === inputData.function) :
                                    null
                                }
                                getOptionLabel={(option) => option.function}
                                getOptionValue={(option) => option.id}
                                onChange={(event) => handleSeclect(event)}
                                placeholder="Choose.."
                                isClearable={true}
                                styles={customStyles}

                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </div >
    )
}

const mapStateToProps = (state) => {
    const functions = state.admin.functions;
    const jobTitles = state.admin.jobTitles;

    return {
        functions: functions,
        jobTitles: jobTitles,
    };
};

const mapDispatchToProps = (dispatch, state) => {
    return {
        addJobTitle: (data) => dispatch(addJobTitlesAction(data)),
        updateJobTitle: (id, data) => dispatch(updateJobTitlesAction(id, data)),
        deleteJobTitle: (id) => dispatch(deleteJobTitlesAction(id)),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(JobTitle);
